import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] Caught error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-[#e0f6ff] via-[#b3d8f6] to-[#87ceeb] flex items-center justify-center p-4">
          <div className="text-center max-w-md mx-auto bg-white/70 backdrop-blur-md rounded-3xl p-8 shadow-2xl border border-white/60">
            <div className="text-6xl mb-4">😵</div>
            <h1 className="text-2xl font-bold text-[#1e40af] mb-3">
              Ôi! Có lỗi xảy ra
            </h1>
            <p className="text-gray-600 mb-6 text-sm leading-relaxed">
              Trang gặp lỗi không mong đợi. Hãy thử tải lại trang — thường thì sẽ ổn ngay thôi!
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="bg-gradient-to-r from-[#1e40af] to-[#1d4ed8] text-white px-6 py-2.5 rounded-full font-semibold hover:from-[#1d4ed8] hover:to-[#1a3a8a] transition-all shadow-md hover:shadow-lg"
              >
                🔄 Tải lại trang
              </button>
              <button
                onClick={() => { window.location.href = '/'; }}
                className="bg-white text-[#1e40af] border border-[#87ceeb] px-6 py-2.5 rounded-full font-semibold hover:bg-blue-50 transition-all shadow"
              >
                🏠 Về trang chủ
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
